import type { FC } from 'react';
import { Toaster } from 'sonner';

import type { Container } from './container';
import { AppRoot } from './lib/components/AppRoot';
import { StageShell } from './lib/stage/StageShell.tsx';
import { GalleryView } from './lib/a2ui/gallery/GalleryView.tsx';
import { observer } from 'mobx-react-lite';
import { SITE_CONFIG } from './agent/site-config.ts';

export const App: FC<{ container: Container }> = observer(({ container }) => {
  // Dev/design review: `?gallery=1` renders every builtin surface with
  // fixture data — standalone, no session/agent bootstrapping.
  if (new URLSearchParams(window.location.search).has('gallery')) {
    return <GalleryView />;
  }
  return (
    <AppRoot container={container}>
      <Toaster />
      <StageShell
        logo={SITE_CONFIG.logo}
        appearance={SITE_CONFIG.appearance}
        placeholder={SITE_CONFIG.placeholder}
        voiceEnabled={SITE_CONFIG.voiceEnabled}
      />
    </AppRoot>
  );
});
